import { ArticleItem } from '@domains/article';
import { CategoryPreviewResponse } from '@domains/categories';
import { Seo } from '@domains/seo';

import { Product } from './product';

export type Identifier =
    | FeipApi.Slug
    | {
          id: number;
      };

export type ProductsCatalogLanding = {
    categories: CategoryPreviewResponse[];
    news: ArticleItem[];
    seo: Seo;
};

export type ProductsCatalogCategoriesList = {
    items: CategoryPreviewResponse[];
};

export enum ProductsListSortMode {
    Novelty = 'novelty',
    Popularity = 'popularity',
    PriceAscending = 'price_ascending',
    PriceDescending = 'price_descending',
    Relevance = 'relevance',
    NameAscending = 'name_ascending',
    NameDescending = 'name_descending',
}

export type ProductsListFilters = {
    is_novelty?: boolean;
    is_promo?: boolean;
    is_ready_to_eat?: boolean;
    min_price?: FeipApi.Kopecks;
    max_price?: FeipApi.Kopecks;
    countries?: string[];
    manufacturers?: string[];
};

export type ProductsListAvailableFilters = {
    is_novelty: boolean;
    is_ready_to_eat: boolean;
    is_promo: boolean;
    min_price: FeipApi.Kopecks | null;
    max_price: FeipApi.Kopecks | null;
    countries: string[];
    manufacturers: string[];
};

export type ProductsListRequest = {
    sort_mode: ProductsListSortMode;
    category_identifier?: Identifier;
    search_query?: string;
    page: number;
    page_size: number;
    filters?: ProductsListFilters;
};

export type ProductsListData = FeipApi.PaginateList<Product> & {
    categories: CategoryPreviewResponse[];
    available_filters: ProductsListAvailableFilters;
};

export type CheckboxFilter = {
    onSelect: (value: boolean) => void;
    label: string;
    isSelected: boolean;
};

export type AccordionFilters = {
    countries: CheckboxFilter[];
    manufacturers: CheckboxFilter[];
};

export type ProductsAutocompleteRequest = {
    search_query: string;
    limit: number;
};
